// src/Components/Forms/Financement/Salam/Proposition/Tab1.tsx
import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { Form } from 'antd';
import InputForm from '../../../../InputT';
import SearchModal from '../../../../SearchModal';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';

// Paramètres de recherche
let searchSalam: ParamsPicklist = {
  CodeAgence: '',
  Table: "ParamsSalam",
  Colonne1: "CodeSalam",
  Colonne2: "LibelleSalam",
  Colagence: '101',
  Choix: 22
};

let searchGes: ParamsPicklist = {
  CodeAgence: '',
  Table: "GESTIONNAIRE",
  Colonne1: "CODGES",
  Colonne2: "LIBELLE",
  Colagence: '101',
  Choix: 22
};

let searchClient: ParamsPicklist = {
  CodeAgence: '',
  Table: "CLIENT",
  Colonne1: "NUMCLI",
  Colonne2: "NOMCLI",
  Colagence: '101',
  Choix: 22
};

let searchUnite: ParamsPicklist = {
  CodeAgence: '',
  Table: "Unite",
  Colonne1: "CodeUnite",
  Colonne2: "Libelle",
  Colagence: '101',
  Choix: 22
};

let searchActif: ParamsPicklist = {
  CodeAgence: '',
  Table: "Actif",
  Colonne1: "CodeActif",
  Colonne2: "Designation",
  Colagence: '101',
  Choix: 22
};

let searchNature: ParamsPicklist = {
  CodeAgence: 'ACTIVITE',
  Table: "LIB",
  Colonne1: "CODLIB",
  Colonne2: "LIBELL",
  Colagence: 'RUBRIQ',
  Choix: 22
};

interface Tab1Props {
  form?: any;
}

const Tab1 = (props: Tab1Props) => {
  const disabled = true; // champs en lecture seule (sauf exceptions)

  // Watchers pour le recalcul du prix unitaire
  const quantite = Form.useWatch('Quantite', props.form) || 0;
  const montantPropose = Form.useWatch('MontantPropose', props.form) || 0;

  // Recalcul du prix unitaire (affiché en lecture seule)
  useEffect(() => {
    if (quantite > 0) {
      const prixUnitaire = montantPropose / quantite;
      props.form.setFieldValue('PrixUnitaire', Math.round(prixUnitaire * 100) / 100);
    } else {
      props.form.setFieldValue('PrixUnitaire', 0);
    }
  }, [quantite, montantPropose, props.form]);

  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={"85%"} position={"absolute"}>
        <Box className="border-left" p={1}>
          <Grid container spacing={0}>

            {/* Ligne 1 : Type Salam + Numéro Demande */}
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Type Salam"
                label="Type Salam"
                name="CodeSalam"
                form={props.form}
                Parametre={searchSalam}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputForm
                width={7}
                label="Numéro Demande"
                name="NumeroDemande"
                disabled={disabled}
                type="text"
              />
            </Grid>

            {/* Ligne 2 : Client + Compte règlement */}
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Client"
                label="Client"
                name="NUMCLI"
                form={props.form}
                Parametre={searchClient}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputForm
                width={7}
                label="Compte de règlement"
                name="CPTREGLEMENT"
                disabled={disabled}
                type="text"
              />
            </Grid>

            {/* Ligne 3 : Gestionnaire (modifiable) + Activité */}
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Gestionnaire"
                label="Gestionnaire"
                name="CODGEA"
                form={props.form}
                Parametre={searchGes}
                // modifiable (pas de prop disabled)
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Secteur d'activité"
                label="Activité"
                name="CODACTIVE"
                form={props.form}
                Parametre={searchNature}
                disabled={disabled}
                notRequired
              />
            </Grid>

            {/* Ligne 4 : Produit + Unité */}
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Actif"
                label="Produit"
                name="CodeActif"
                form={props.form}
                Parametre={searchActif}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Unité"
                label="Unité"
                name="Unite"
                form={props.form}
                Parametre={searchUnite}
                disabled={disabled}
              />
            </Grid>

            {/* Ligne 5 : Quantité (modifiable) + Prix unitaire (calculé) + Montant proposé (modifiable) */}
            <Grid item xs={12} md={4}>
              <InputForm
                width={8}
                label="Quantité"
                name="Quantite"
                type="number"
                money
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InputForm
                width={8}
                label="Prix unitaire"
                name="PrixUnitaire"
                disabled={true}
                type="number"
                money
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InputForm
                width={8}
                label="Montant proposé"
                name="MontantPropose"
                type="number"
                money
              />
            </Grid>

            {/* Ligne 6 : Frais de service (calculé par le parent, lecture seule) */}
            <Grid item xs={12} md={4}>
              <InputForm
                width={8}
                label="Frais service"
                name="FraisService"
                disabled={true}
                type="number"
                notRequired
                money
              />
            </Grid>

            {/* Ligne 7 : Date livraison + Objet */}
            <Grid item xs={12} md={4}>
              <InputForm
                width={8}
                label="Date livraison"
                name="DateLivraison"
                disabled={disabled}
                type="date"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InputForm
                width={8}
                label="Objet"
                name="CODOBJECT"
                disabled={disabled}
                type="text"
                notRequired
              />
            </Grid>

            {/* Ligne 8 : Lieu livraison + Commentaire */}
            <Grid item xs={12} md={6}>
              <InputForm
                width={5}
                label="Lieu de livraison"
                name="LieuLivraison"
                disabled={disabled}
                type="text"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputForm
                width={7}
                label="Commentaire"
                name="CommentaireDemande"
                disabled={false}
                type="TextArea"
              />
            </Grid>

          </Grid>
        </Box>
      </Box>
    </div>
  );
};

export default Tab1;